import styled from 'styled-components';

export const RadioGroupFieldWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: fit-content;
  border: 1px solid transparent;
  border-radius: 3px;
`;
